import { useMutation } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { ExportIncidents } from '../mutations/exportIncidents.mutation';
import type { ExportIncidentsMutation, ExportIncidentsMutationVariables } from '../types';

export const useExportIncidentsMutation = (
  options?: MutationOptions<ExportIncidentsMutation, ExportIncidentsMutationVariables>,
) => {
  return useMutation(gqlFetcher(ExportIncidents), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);
    },
  });
};
